module.exports = __webpack_public_path__ + "img/service_qnabg.27b644a9.jpg";